import React from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import PageHeader from "../../../shared/components/PageHeader";
import ActivityLogTable from "./components/ActivityLogTable.js";

const AuditTrail = () => (
  <Container>
    <PageHeader header="Activity Log" />
    <Row>
      <ActivityLogTable />
    </Row>
  </Container>
);

export default connect((state) => ({
  requests: state.getAllCardRequests,
}))(AuditTrail);
